import { TEST_WEBINAR_MAX_DURATION_MINUTES, WebinarStatus, testWebinarEndDeadline } from '@core/types';
import { useAppSelector } from '@online-webinar/store';
import { Duration } from 'luxon';
import { useTranslation } from 'react-i18next';

/**
 * The broadcaster's view of the 15-minute cap (spec §5.2): the limit before the start, a countdown
 * to the same deadline the server uses (min(StartedOn + 15 min, booking end)) once started, nothing
 * after the end. Display only — the server's reminder is the rule.
 */
export const TestWebinarCountdown = () => {
    const { t } = useTranslation();
    const isTest = useAppSelector((state) => state.liveWebinar.webinarData.isTest);
    const status = useAppSelector((state) => state.liveWebinar.webinarData.status);
    const startedOn = useAppSelector((state) => state.liveWebinar.webinarData.startedOn);
    const endOn = useAppSelector((state) => state.liveWebinar.endOn);
    const serverTime = useAppSelector((state) => state.liveWebinar.serverTime);

    if (!isTest) return null;

    if (status === WebinarStatus.Planned) {
        return (
            <div data-testid="test-webinar-countdown" className="bg-warning text-white px-4 py-1 text-center">
                {t('Webinar.Test.Countdown.Limit', { maxDurationMinutes: TEST_WEBINAR_MAX_DURATION_MINUTES })}
            </div>
        );
    }

    if (status !== WebinarStatus.Started) return null;

    const deadline = testWebinarEndDeadline(startedOn, endOn);
    const now = serverTime ? new Date(serverTime).getTime() : Date.now();
    const remaining = Duration.fromMillis(Math.max(0, (deadline ?? now) - now));

    return (
        <div data-testid="test-webinar-countdown" className="bg-warning text-white px-4 py-1 text-center">
            {t('Webinar.Test.Countdown.Ending')} <span className="text-xl md:text-2xl">{remaining.toFormat('mm:ss')}</span>
        </div>
    );
};
